"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var password_1 = require("./password");
exports.PasswordService = password_1.PasswordService;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/password_reset/services/index.js
// module id = 335
// module chunks = 0